module.exports = __webpack_public_path__ + "img/li.0b12f4be.png";